(function () {
  'use strict';

  if (window.__dbGa4CommerceContextLoaded) return;
  window.__dbGa4CommerceContextLoaded = true;
  window.__dbGa4BlogAttributionVersion = '2026-08-30';

  var config = window.DB_GA4_COMMERCE_CONTEXT || {};
  var storagePrefix = 'dbe.ga4.list_context.v1:';
  var currentStorageKey = storagePrefix + 'current';
  var blogStoragePrefix = 'dbe.ga4.blog_context.v1:';
  var currentBlogStorageKey = blogStoragePrefix + 'current';
  var contextTtlMs = 2 * 60 * 60 * 1000;
  var eventCounter = 0;
  var observedCards = new WeakSet();
  var pendingLists = {};
  var pendingTimer = null;
  var quickAddCard = null;
  var lastSizeInteraction = null;
  var lastUnavailableKey = '';
  var lastUnavailableAt = 0;
  var lastSelectedKey = '';
  var lastSelectedAt = 0;

  var isPreview = config.themeRole !== 'main' ||
    /(?:\?|&)preview_theme_id=/.test(window.location.search) ||
    Boolean(window.Shopify && window.Shopify.designMode);
  var shouldSend = Boolean(config.enabled && !isPreview && config.measurementId);

  if (isPreview) {
    window.__dbGa4EventLog = window.__dbGa4EventLog || [];
  }

  function safeJsonParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^.*\/products\//, '')
      .replace(/[?#].*$/, '')
      .replace(/\/$/, '');
  }

  function baseSku(value) {
    return String(value || '').replace(/-UK\s*\d+(?:\.5)?$/i, '');
  }

  function titleize(value) {
    return String(value || '')
      .replace(/^shopify-section-/, '')
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); })
      .trim();
  }

  function nextEventId(eventName) {
    eventCounter += 1;
    return ['dbe', eventName, Date.now().toString(36), eventCounter].join('_');
  }

  function ensureGoogleTag() {
    if (!shouldSend) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    if (!window.__dbGa4CommerceContextConfigured) {
      window.__dbGa4CommerceContextConfigured = true;
      window.gtag('config', config.measurementId, { send_page_view: false });

      var selector = 'script[src*="' + config.measurementId + '"]';
      if (!document.querySelector(selector)) {
        var loader = document.createElement('script');
        loader.async = true;
        loader.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(config.measurementId);
        document.head.appendChild(loader);
      }
    }
  }

  function emit(eventName, params) {
    var payload = Object.assign({}, params || {}, {
      dbe_event_id: nextEventId(eventName)
    });

    if (isPreview) {
      window.__dbGa4EventLog.push({
        event: eventName,
        params: payload,
        captured_at: new Date().toISOString()
      });
      if (window.__dbGa4EventLog.length > 200) {
        window.__dbGa4EventLog.shift();
      }
      console.info('[DB-GA4-PREVIEW]', eventName, JSON.stringify(payload));
    }

    document.dispatchEvent(new CustomEvent('dbe:ga4-event', {
      detail: { event: eventName, params: payload }
    }));

    if (shouldSend) {
      ensureGoogleTag();
      window.gtag('event', eventName, payload);
    }

    return payload.dbe_event_id;
  }

  function setGlobalListContext(context) {
    if (!context || !shouldSend) return;
    ensureGoogleTag();
    window.gtag('set', {
      item_list_id: context.item_list_id,
      item_list_name: context.item_list_name,
      item_list_position: context.item_list_position
    });
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return false;
    }
    return true;
  }

  function storageGet(key) {
    try {
      return safeJsonParse(window.sessionStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }

  function isFreshContext(context) {
    return Boolean(context && context.saved_at && Date.now() - context.saved_at <= contextTtlMs);
  }

  function readContext(handle) {
    var normalized = normalizeHandle(handle);
    var byHandle = normalized ? storageGet(storagePrefix + normalized) : null;
    if (isFreshContext(byHandle)) return byHandle;

    var current = storageGet(currentStorageKey);
    if (!isFreshContext(current)) return null;
    if (!normalized || current.product_handle === normalized) return current;
    return null;
  }


  function saveBlogContext(context) {
    if (!context) return null;
    var stored = Object.assign({}, context, { saved_at: Date.now() });
    var destinationHandle = normalizeHandle(stored.destination_handle);
    if (stored.destination_type === 'product' && destinationHandle) {
      storageSet(blogStoragePrefix + destinationHandle, stored);
    }
    storageSet(currentBlogStorageKey, stored);
    return stored;
  }

  function readBlogContext(handle) {
    var normalized = normalizeHandle(handle);
    var byHandle = normalized ? storageGet(blogStoragePrefix + normalized) : null;
    if (isFreshContext(byHandle)) return byHandle;
    var current = storageGet(currentBlogStorageKey);
    return isFreshContext(current) ? current : null;
  }

  function blogContextParams(context) {
    if (!context) return {};
    return {
      blog_article_handle: context.article_handle || '',
      blog_article_title: context.article_title || '',
      blog_handle: context.blog_handle || '',
      blog_module_name: context.module_name || '',
      blog_destination_type: context.destination_type || '',
      blog_destination_handle: context.destination_handle || '',
      blog_destination_path: context.destination_path || '',
      blog_cta_id: context.blog_cta_id || '',
      blog_link_position: Number(context.link_position || 0),
      blog_context_age_seconds: Math.max(0, Math.round((Date.now() - context.saved_at) / 1000))
    };
  }

  function listContainer(card) {
    return card.closest('[data-collection], .products, #product-grid, .shopify-section') || card.parentElement;
  }

  function computePosition(card, container) {
    var explicit = parseInt(card.dataset.itemListPosition || '0', 10);
    if (explicit > 0) return explicit;
    if (!container) return 1;

    var cards = Array.prototype.slice.call(
      container.querySelectorAll('product-card[data-db-ga4-product-card]')
    );
    var index = cards.indexOf(card);
    return index >= 0 ? index + 1 : 1;
  }

  function listDetails(card) {
    var container = listContainer(card);
    var ancestorCollection = card.closest('[data-collection]');
    var pageList = config.pageList || {};
    var section = card.closest('.shopify-section');
    var listId = card.dataset.itemListId ||
      (ancestorCollection && ancestorCollection.dataset.collection) ||
      pageList.id ||
      (section && section.id) ||
      'product-list';
    var listName = card.dataset.itemListName ||
      pageList.name ||
      (ancestorCollection && titleize(ancestorCollection.dataset.collection)) ||
      titleize(listId) ||
      'Product list';
    var position = computePosition(card, container);

    return {
      item_list_id: String(listId),
      item_list_name: String(listName),
      item_list_position: position,
      index: Math.max(position - 1, 0)
    };
  }

  function cardItem(card, details) {
    var priceCents = parseInt(card.dataset.itemPriceCents || '0', 10);
    var item = {
      item_id: card.dataset.itemId || card.dataset.variantId || card.dataset.productId || '',
      item_name: card.dataset.itemName || '',
      item_brand: card.dataset.itemBrand || '',
      item_variant: card.dataset.itemVariant || '',
      variant_sku: card.dataset.variantSku || '',
      shopify_product_id: card.dataset.productId || '',
      shopify_variant_id: card.dataset.variantId || '',
      product_handle: card.dataset.productHandle || '',
      price: Number.isFinite(priceCents) ? priceCents / 100 : 0
    };

    if (details) {
      item.item_list_id = details.item_list_id;
      item.item_list_name = details.item_list_name;
      item.item_list_position = details.item_list_position;
      item.index = details.index;
    }
    return item;
  }

  function persistCardContext(card) {
    var details = listDetails(card);
    var item = cardItem(card, details);
    var handle = normalizeHandle(card.dataset.productHandle || card.dataset.productUrl);
    var context = {
      product_handle: handle,
      product_path: card.dataset.productUrl || '',
      item_id: item.item_id,
      product_id: item.shopify_product_id,
      variant_id: item.shopify_variant_id,
      item_list_id: details.item_list_id,
      item_list_name: details.item_list_name,
      item_list_position: details.item_list_position,
      index: details.index,
      saved_at: Date.now()
    };

    if (handle) storageSet(storagePrefix + handle, context);
    storageSet(currentStorageKey, context);
    setGlobalListContext(context);
    return context;
  }

  function eventParams(details, items) {
    var params = {
      currency: config.currency || 'GBP',
      item_list_id: details.item_list_id,
      item_list_name: details.item_list_name,
      item_list_position: details.item_list_position,
      items: items
    };
    return params;
  }

  function flushVisibleCards() {
    pendingTimer = null;
    Object.keys(pendingLists).forEach(function (key) {
      var group = pendingLists[key];
      if (!group || !group.items.length) return;
      emit('view_item_list', eventParams(group.details, group.items));
    });
    pendingLists = {};
  }

  function queueVisibleCard(card) {
    if (card.dataset.dbGa4Viewed === 'true') return;
    card.dataset.dbGa4Viewed = 'true';

    var details = listDetails(card);
    var key = details.item_list_id + '::' + details.item_list_name;
    if (!pendingLists[key]) {
      pendingLists[key] = { details: details, items: [] };
    }
    pendingLists[key].items.push(cardItem(card, details));

    if (!pendingTimer) {
      pendingTimer = window.setTimeout(flushVisibleCards, 80);
    }
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
        queueVisibleCard(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: [0.2], rootMargin: '0px 0px 100px 0px' }) : null;

  function registerCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('product-card[data-db-ga4-product-card]');
    cards.forEach(function (card) {
      if (observedCards.has(card)) return;
      observedCards.add(card);
      if (observer) observer.observe(card);
      else queueVisibleCard(card);
    });
  }

  function closestProductAction(target) {
    return target.closest('a[href*="/products/"], [data-db-size-sheet-trigger]');
  }

  document.addEventListener('pointerdown', function (event) {
    var action = closestProductAction(event.target);
    var card = action && action.closest('product-card[data-db-ga4-product-card]');
    if (!card) return;
    persistCardContext(card);
    if (action.matches('[data-db-size-sheet-trigger]')) quickAddCard = card;
  }, true);

  document.addEventListener('click', function (event) {
    var action = closestProductAction(event.target);
    var card = action && action.closest('product-card[data-db-ga4-product-card]');
    if (!card) return;

    var details = listDetails(card);
    persistCardContext(card);
    var selectedItem = cardItem(card, details);
    var selectedParams = eventParams(details, [selectedItem]);
    Object.assign(selectedParams, blogContextParams(readBlogContext(selectedItem.product_handle)));
    emit('select_item', selectedParams);
    if (action.matches('[data-db-size-sheet-trigger]')) quickAddCard = card;
  });

  function isSizeFieldset(fieldset) {
    var handle = String(fieldset && fieldset.dataset.handle || '').toLowerCase();
    return handle === 'size' || handle === 'sizes' || handle.indexOf('shoe-size') >= 0 || handle.indexOf('uk-size') >= 0;
  }

  function sizeControl(target) {
    var label = target.closest('label');
    var fieldset = target.closest('fieldset.product-form__input');
    if (!fieldset || !isSizeFieldset(fieldset)) return null;

    var control = null;
    if (label) {
      var controlId = label.getAttribute('for');
      control = controlId ? document.getElementById(controlId) : null;
    }
    if (!control) control = target.closest('input, select');
    return { fieldset: fieldset, control: control, label: label };
  }

  function controlValue(controlInfo) {
    var control = controlInfo && controlInfo.control;
    if (!control) return '';
    if (control.tagName === 'SELECT') return control.value;
    return control.value || (controlInfo.label && controlInfo.label.textContent.trim()) || '';
  }

  function productBaseItem(variant) {
    var product = config.product || {};
    var variantData = variant || {};
    var price = Number(variantData.price);
    if (!Number.isFinite(price)) price = Number(product.price || 0);
    if (variantData._price_is_minor_units) price = price / 100;
    return {
      item_id: baseSku(variantData.sku || product.item_id) || String(variantData.id || product.variant_id || product.product_id || ''),
      item_name: product.item_name || '',
      item_brand: product.item_brand || '',
      item_variant: variantData.public_title || variantData.title || product.item_variant || '',
      variant_sku: variantData.sku || product.variant_sku || '',
      shopify_product_id: String(product.product_id || ''),
      shopify_variant_id: String(variantData.id || product.variant_id || ''),
      product_handle: product.product_handle || '',
      price: price
    };
  }

  function selectedProductVariant() {
    var product = config.product || {};
    if (!Array.isArray(product.variants)) return null;

    var selectedOptions = {};
    document.querySelectorAll('fieldset.product-form__input[data-index]').forEach(function (fieldset) {
      var index = fieldset.dataset.index;
      var selected = fieldset.querySelector('input:checked, select');
      if (index && selected) selectedOptions[index] = selected.value;
    });

    var selected = product.variants.find(function (variant) {
      return Object.keys(selectedOptions).every(function (index) {
        return String(variant[index] || '') === String(selectedOptions[index] || '');
      });
    }) || null;
    return selected ? Object.assign({}, selected, { _price_is_minor_units: true }) : null;
  }

  function productVariantForSize(size) {
    var product = config.product || {};
    if (!Array.isArray(product.variants)) return null;
    var normalizedSize = String(size || '').trim();
    var variant = product.variants.find(function (candidate) {
      return [candidate.option1, candidate.option2, candidate.option3, candidate.public_title, candidate.title]
        .some(function (value) { return String(value || '').trim() === normalizedSize; });
    }) || null;
    return variant ? Object.assign({}, variant, { _price_is_minor_units: true }) : null;
  }

  function contextParams(context) {
    if (!context) return {};
    return {
      item_list_id: context.item_list_id,
      item_list_name: context.item_list_name,
      item_list_position: context.item_list_position,
      index: context.index
    };
  }

  function enrichItemWithContext(item, context) {
    if (!context) return item;
    return Object.assign({}, item, contextParams(context));
  }

  function emitSizeSelected(size, variant, source, context, itemOverride) {
    var key = [source, size, variant && variant.id || ''].join('::');
    if (key === lastSelectedKey && Date.now() - lastSelectedAt < 750) return;
    lastSelectedKey = key;
    lastSelectedAt = Date.now();

    var item = itemOverride || productBaseItem(variant);
    item = enrichItemWithContext(item, context);
    var params = Object.assign({
      currency: config.currency || 'GBP',
      selected_size: size,
      size_available: true,
      selection_source: source,
      variant_id: String(variant && variant.id || item.shopify_variant_id || ''),
      items: [item]
    }, contextParams(context), blogContextParams(readBlogContext(item.product_handle)));
    emit('size_selected', params);
  }

  document.addEventListener('pointerdown', function (event) {
    var info = sizeControl(event.target);
    if (!info || !info.control) return;
    var unavailable = info.control.disabled || info.control.dataset.available === 'false';
    if (!unavailable) return;

    var size = controlValue(info);
    var key = [config.product && config.product.product_handle || '', size].join('::');
    if (key === lastUnavailableKey && Date.now() - lastUnavailableAt < 750) return;
    lastUnavailableKey = key;
    lastUnavailableAt = Date.now();

    var context = readContext(config.product && config.product.product_handle);
    var unavailableVariant = productVariantForSize(size);
    var item = enrichItemWithContext(productBaseItem(unavailableVariant), context);
    emit('unavailable_size_selected', Object.assign({
      currency: config.currency || 'GBP',
      selected_size: size,
      size_available: false,
      variant_id: String(unavailableVariant && unavailableVariant.id || ''),
      items: [item]
    }, contextParams(context), blogContextParams(readBlogContext(item.product_handle))));
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.isTrusted) return;
    var info = sizeControl(event.target);
    if (!info || !info.control) return;
    lastSizeInteraction = {
      size: controlValue(info),
      available: !info.control.disabled && info.control.dataset.available !== 'false',
      at: Date.now()
    };
    window.setTimeout(function () {
      if (!lastSizeInteraction || Date.now() - lastSizeInteraction.at > 1200) return;
      var interaction = lastSizeInteraction;
      var variant = selectedProductVariant();
      if (!interaction.available || !variant || variant.available === false) return;
      var context = readContext(config.product && config.product.product_handle);
      emitSizeSelected(interaction.size, variant, 'product_page', context, null);
      lastSizeInteraction = null;
    }, 0);
  }, true);

  document.addEventListener('product:variant-change', function (event) {
    if (config.product && Array.isArray(config.product.variants)) return;
    if (!lastSizeInteraction || Date.now() - lastSizeInteraction.at > 1200) return;
    var interaction = lastSizeInteraction;
    lastSizeInteraction = null;
    var variant = event.detail && event.detail.variant;
    if (!interaction.available || !variant || variant.available === false) return;
    var context = readContext(config.product && config.product.product_handle);
    emitSizeSelected(interaction.size, variant, 'product_page', context, null);
  });

  document.addEventListener('click', function (event) {
    var sizeButton = event.target.closest('.db-size-sheet__size');
    if (!sizeButton || !quickAddCard) return;
    var dataNode = quickAddCard.querySelector('.db-card-size-data');
    var cardData = dataNode ? safeJsonParse(dataNode.getAttribute('data-json') || dataNode.textContent) : null;
    var size = sizeButton.textContent.trim();
    var variant = cardData && Array.isArray(cardData.variants) ? cardData.variants.find(function (candidate) {
      return String(candidate.label).trim() === size;
    }) : null;
    var context = persistCardContext(quickAddCard);
    var item = cardItem(quickAddCard, listDetails(quickAddCard));
    if (variant) {
      item.item_id = baseSku(variant.sku) || item.item_id;
      item.variant_sku = variant.sku || item.variant_sku;
      item.shopify_variant_id = String(variant.id || item.shopify_variant_id);
      item.item_variant = variant.label || item.item_variant;
    }
    emitSizeSelected(size, variant || {}, 'collection_quick_add', context, item);
  });

  document.addEventListener('cart:item-added', function (event) {
    var product = event.detail && event.detail.product || {};
    var productHandle = normalizeHandle(product.handle || (config.product && config.product.product_handle));
    var context = quickAddCard ? persistCardContext(quickAddCard) : readContext(productHandle);
    var blogContext = readBlogContext(productHandle);
    if (!context && !blogContext) return;

    if (context) setGlobalListContext(context);
    var item = quickAddCard ? cardItem(quickAddCard, listDetails(quickAddCard)) : productBaseItem({
      id: product.variant_id || product.id,
      sku: product.sku,
      title: product.variant_title,
      price: product.final_price || product.price,
      _price_is_minor_units: true
    });
    item = enrichItemWithContext(item, context);
    item.quantity = Number(product.quantity || 1);
    if (product.sku) {
      item.item_id = baseSku(product.sku) || item.item_id;
      item.variant_sku = product.sku;
    }
    if (product.variant_id) item.shopify_variant_id = String(product.variant_id);
    if (product.product_title) item.item_name = product.product_title;
    if (product.vendor) item.item_brand = product.vendor;

    emit('add_to_cart_context', Object.assign({
      currency: config.currency || 'GBP',
      value: Number(item.price || 0) * item.quantity,
      source_event: 'cart:item-added',
      items: [item]
    }, contextParams(context), blogContextParams(blogContext)));
    quickAddCard = null;
  });



  function blogCommerceDestination(anchor) {
    if (!anchor || !anchor.href) return null;

    var parsed;
    try {
      parsed = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return null;
    }

    if (parsed.origin !== window.location.origin) return null;
    var parts = parsed.pathname.split('/').filter(Boolean);
    var productIndex = parts.indexOf('products');
    if (productIndex >= 0 && parts[productIndex + 1]) {
      return {
        type: 'product',
        handle: parts[productIndex + 1],
        path: parsed.pathname,
        ctaId: parsed.searchParams.get('blog_cta') || ''
      };
    }

    var collectionIndex = parts.indexOf('collections');
    if (collectionIndex >= 0 && parts[collectionIndex + 1]) {
      return {
        type: 'collection',
        handle: parts[collectionIndex + 1],
        path: parsed.pathname,
        ctaId: parsed.searchParams.get('blog_cta') || ''
      };
    }
    return null;
  }

  function isBlogCommerceLink(anchor, destination) {
    if (!config.article || !anchor || !destination) return false;
    if (anchor.hasAttribute('data-blog-commerce-click')) return true;
    if (destination.ctaId) return true;
    return Boolean(anchor.closest('#main-article .post-content, [data-blog-commerce-module]'));
  }

  function blogCommerceModule(anchor, destination) {
    var module = anchor.closest('[data-blog-commerce-module]');
    if (module && module.dataset.blogCommerceModule) {
      return module.dataset.blogCommerceModule;
    }
    if (destination.ctaId.indexOf('_intro_') >= 0) return 'intro_shop';
    return destination.type === 'product' ? 'inline_product' : 'inline_collection';
  }

  function blogCommercePosition(anchor) {
    var links = Array.prototype.slice.call(document.querySelectorAll(
      '#main-article .post-content a[href], [data-blog-commerce-module] a[href]'
    )).filter(function (candidate) {
      var destination = blogCommerceDestination(candidate);
      return isBlogCommerceLink(candidate, destination);
    });
    var index = links.indexOf(anchor);
    return index >= 0 ? index + 1 : 0;
  }

  function blogCommerceLabel(anchor) {
    var image = anchor.querySelector('img[alt]');
    return String(
      anchor.getAttribute('aria-label') ||
      anchor.textContent ||
      (image && image.getAttribute('alt')) ||
      anchor.getAttribute('title') ||
      ''
    ).replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  document.addEventListener('click', function (event) {
    if (!config.article) return;
    var target = event.target;
    if (!target || target.nodeType !== 1) target = target && target.parentElement;
    var anchor = target && target.closest ? target.closest('a[href]') : null;
    var destination = blogCommerceDestination(anchor);
    if (!isBlogCommerceLink(anchor, destination)) return;

    var blogContext = {
      article_handle: config.article.handle || '',
      article_title: config.article.title || '',
      blog_handle: config.article.blog_handle || '',
      module_name: blogCommerceModule(anchor, destination),
      destination_type: destination.type,
      destination_handle: destination.handle,
      destination_path: destination.path,
      link_position: blogCommercePosition(anchor),
      cta_label: blogCommerceLabel(anchor),
      blog_cta_id: destination.ctaId
    };
    saveBlogContext(blogContext);
    emit('blog_commerce_click', blogContext);
  }, true);


  var blogCommerceViewNames = {
    top_availability: true,
    mid_context: true,
    end_matrix: true
  };
  var observedBlogCommerceModules = new WeakSet();
  var viewedBlogCommerceModules = new WeakSet();
  var blogCommerceViewTimers = new WeakMap();

  function eligibleBlogCommerceModules() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-blog-commerce-module]')
    ).filter(function (module) {
      return Boolean(blogCommerceViewNames[module.dataset.blogCommerceModule]);
    });
  }

  function blogCommerceModulePosition(module) {
    var modules = eligibleBlogCommerceModules();
    var index = modules.indexOf(module);
    return index >= 0 ? index + 1 : 0;
  }

  function emitBlogCommerceView(module) {
    if (!module || viewedBlogCommerceModules.has(module)) return;
    viewedBlogCommerceModules.add(module);

    var commerceLinks = Array.prototype.slice.call(module.querySelectorAll('a[href]'))
      .filter(function (anchor) { return Boolean(blogCommerceDestination(anchor)); });

    emit('blog_commerce_view', {
      article_handle: config.article.handle || '',
      article_title: config.article.title || '',
      blog_handle: config.article.blog_handle || '',
      module_name: module.dataset.blogCommerceModule || '',
      module_position: blogCommerceModulePosition(module),
      link_count: commerceLinks.length,
      product_count: module.querySelectorAll('[data-dbe-commerce-product-card]').length
    });
  }

  var blogCommerceViewObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var module = entry.target;
      var currentTimer = blogCommerceViewTimers.get(module);

      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        if (viewedBlogCommerceModules.has(module) || currentTimer) return;
        var timer = window.setTimeout(function () {
          blogCommerceViewTimers.delete(module);
          if (module.isConnected !== false) {
            emitBlogCommerceView(module);
            blogCommerceViewObserver.unobserve(module);
          }
        }, 1000);
        blogCommerceViewTimers.set(module, timer);
      } else if (currentTimer) {
        window.clearTimeout(currentTimer);
        blogCommerceViewTimers.delete(module);
      }
    });
  }, { threshold: [0, 0.5, 1] }) : null;

  function registerBlogCommerceViews(root) {
    if (!config.article || !blogCommerceViewObserver) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-blog-commerce-module]').forEach(function (module) {
      if (!blogCommerceViewNames[module.dataset.blogCommerceModule]) return;
      if (observedBlogCommerceModules.has(module)) return;
      observedBlogCommerceModules.add(module);
      blogCommerceViewObserver.observe(module);
    });
  }

  registerBlogCommerceViews(document);
  document.addEventListener('shopify:section:load', function (event) {
    registerBlogCommerceViews(event.target || document);
  });

  if (config.article && shouldSend) {
    ensureGoogleTag();
  }

  var currentProductContext = readContext(config.product && config.product.product_handle);
  if (currentProductContext) setGlobalListContext(currentProductContext);

  var currentBlogContext = readBlogContext(config.product && config.product.product_handle);
  if (config.product && currentBlogContext && !window.__dbeBlogProductViewSent) {
    window.__dbeBlogProductViewSent = true;
    var viewedVariant = selectedProductVariant();
    var viewedItem = enrichItemWithContext(productBaseItem(viewedVariant), currentProductContext);
    emit('blog_product_view', Object.assign({
      currency: config.currency || 'GBP',
      value: Number(viewedItem.price || 0),
      items: [viewedItem]
    }, contextParams(currentProductContext), blogContextParams(currentBlogContext)));
  }

  registerCards(document);
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('product-card[data-db-ga4-product-card]')) {
            registerCards(node.parentElement || document);
          } else {
            registerCards(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
